import React, { useContext } from 'react';
import {
  Button,
  ButtonElevation,
  ButtonText,
  ButtonType,
} from '@prisjakt/ui/button';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { VariantSelectionCallback } from './types';

export const SizeVariantSelectionButton: React.FC<IVariantSelectionButton> = props => {
  const { variant, title, handleSelection } = props;
  const { selectedSizeVariants } = useContext(PriceListFilterContext);

  const isSelected = Boolean(
    (variant && selectedSizeVariants?.includes(variant)) ||
      (!variant && !selectedSizeVariants)
  );

  const onSelect = () => handleSelection(variant);

  return (
    <Button
      onClick={onSelect}
      selectable
      selected={isSelected}
      fullWidth
      type={ButtonType.OUTLINED}
      elevation={ButtonElevation.NONE}
    >
      <ButtonText>{title}</ButtonText>
    </Button>
  );
};

interface IVariantSelectionButton {
  variant: string | null;
  title: string;
  handleSelection: VariantSelectionCallback;
}
